import { View, type ViewProps } from 'react-native';
import { twMerge } from 'tailwind-merge';

interface CardProps extends ViewProps {
  children: React.ReactNode;
  /** 'elevated' adds shadow + faint border; 'flat' is borderless. Default: elevated */
  variant?: 'elevated' | 'flat';
  className?: string;
}

export function Card({ children, variant = 'elevated', className = '', style, ...rest }: CardProps) {
  const base = 'bg-white dark:bg-gray-800 rounded-2xl p-4';
  const elevated = 'shadow-card border border-black/5 dark:border-white/10';
  return (
    <View
      className={twMerge(base, variant === 'elevated' ? elevated : '', className)}
      style={style}
      {...rest}
    >
      {children}
    </View>
  );
}
